







































































import moment from 'moment'
import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import { Action, State, Mutation } from 'vuex-class'
import DeleteRateConfirm from '@/modules/shipping/components/DeleteRateConfirm.vue'
import CostCalculator from '@/modules/shipping/components/CostCalculator.vue'
import Rate from '@/modules/shipping/model/Rate';
import {DateMixin} from '@/modules/core/date';

/**
 * Lista con las tarifas registradas en el sistema
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'delete-rate-confirm': DeleteRateConfirm,
        CostCalculator,
    },
})
export default class RateList extends mixins(DateMixin) {
    @State(state => state.shipping.rates)
    public rates: Rate[]

    @State(state => state.shipping.loadingRates)
    public loadingRates: boolean

    @Action('shipping/loadRateList')
    public loadRateList: () => void

    @Mutation('shipping/rate/deleting/set')
    public setDeletingRate: (deleting: boolean) => void

    @Mutation('shipping/rate/to-delete/set')
    public setRateToDelete: (rate: Rate) => void

    public costCalculator = false
    public displayMode = 0

    /**
     * Cabeceras de la tabla
     */
    public headers = [
        { text: 'Id', value: 'id'},
        { text: 'Nombre de la tarifa', value: 'name'},
        { text: 'Transportista', value: 'carrier.id'},
        { text: 'Creación', value: 'createdAt'},
        { text: 'Última actualización', value: 'updatedAt'},
        { text: 'Acciones', sortable: false, align: 'center'},
    ]

    public get isMobile () {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    }

    public deleteRate (rate: Rate) {
        this.setDeletingRate(true)
        this.setRateToDelete(rate)
    }

    public async created () {
        this.loadRateList()
    }
}
